<template>
    <div>
        <slot name="before_description"/>

        <p v-if="$slots.before_description" class="subheading">{{ $t('label.position_description') }}:</p>

        <missing-info v-if="!hideDescription && !position.operation_description && !position.tender && !position.operations?.length && !position.start_date && !position.end_date && !position.full_address && !position.is_remote && !$slots.after_description"
        :text="$t('missing.position.operation_description', {club: position.club?.display_name ?? group.display_name})" class="mt-8"/>
        <template v-else>
            <template v-if="!hideDescription">
                <user-content v-if="position.operation_description" :text="position.operation_description" class="mb-16"/>
                <user-content v-else-if="position.tender" :text="position.tender" class="mb-16"/>
                <p v-else-if="position.short_description" class="mb-16 whitespace-pre-wrap">{{ position.short_description }}</p>
            </template>

            <slot name="after_description"/>

            <position-operation-content v-if="!position.operations?.length" :operation="position" :assignment="assignment" :hide-description="hideDescription">
				<description-list-item v-if="position.club && !hideClub" :title="$t('label.managed_by')">
					<template #text>
						<a :href="$spoferanUrl(`clubs/${position.club._key}`)" class="flex items-center" target="_blank">
							<avatar :model="position.club" :size="24" class="mr-8"/>
							<span :style="{color: position.club.color}" class="table-text-line">{{ position.club.display_name }}</span>
						</a>
					</template>
				</description-list-item>
				<description-list-item v-if="position.manager" :title="$t('label.contact_person')">
					<template #text>
						<div class="flex items-center">
							<avatar :model="position.manager" :size="24" class="mr-8" round/>
							<span class="table-text-line">{{ position.manager.display_name }}</span>
						</div>
					</template>
				</description-list-item>
            </position-operation-content>
            <position-operation-content v-else-if="position.operations?.length === 1" :operation="position.operations[0]" :assignment="assignment" :hide-description="hideDescription">
				<description-list-item v-if="position.club && !hideClub" :title="$t('label.managed_by')">
					<template #text>
						<a :href="$spoferanUrl(`clubs/${position.club._key}`)" class="flex items-center" target="_blank">
							<avatar :model="position.club" :size="24" class="mr-8"/>
							<span :style="{color: position.club.color}" class="table-text-line">{{ position.club.display_name }}</span>
						</a>
					</template>
				</description-list-item>
				<description-list-item v-if="position.manager" :title="$t('label.contact_person')">
					<template #text>
						<div class="flex items-center">
							<avatar :model="position.manager" :size="24" class="mr-8" round/>
							<span class="table-text-line">{{ position.manager.display_name }}</span>
						</div>
					</template>
				</description-list-item>
            </position-operation-content>
            <template v-else>
                <description-list v-if="position.club || position.start_date || position.end_date">
					<description-list-item v-if="position.start_date || position.end_date" :title="$t('label.operation_time')">
						<template #text>
							<dynamic-date-range :start="position.start_date" :end="position.end_date" time>
							</dynamic-date-range>
						</template>
					</description-list-item>
					<description-list-item v-if="position.club && !hideClub" :title="$t('label.managed_by')">
						<template #text>
							<a :href="$spoferanUrl(`clubs/${position.club._key}`)" class="flex items-center" target="_blank">
								<avatar :model="position.club" :size="24" class="mr-8"/>
								<span :style="{color: position.club.color}" class="table-text-line">{{ position.club.display_name }}</span>
							</a>
						</template>
					</description-list-item>
					<description-list-item v-if="position.manager" :title="$t('label.contact_person')">
						<template #text>
							<div class="flex items-center">
								<avatar :model="position.manager" :size="24" class="mr-8" round/>
								<span class="table-text-line">{{ position.manager.display_name }}</span>
							</div>
						</template>
					</description-list-item>
                </description-list>

                <expansion-panels v-if="position.operations?.length">
                    <expansion-panel v-for="operation in position.operations" :key="operation.id" :title="operation.title">
                        <position-operation-content :operation="operation" :assignment="assignment" :hide-description="hideDescription"/>
                    </expansion-panel>
                </expansion-panels>
            </template>
        </template>
    </div>
</template>

<script>
export default {
    name: "PositionOperationsContent",

    props: {

        // The position or the position posting whose operations to display
        position: {
            type: Object,
            required: true
        },

        // The group that manages the position
        group: {
            type: Object,
            required: true
        },

        // The user job model that hold's user specific assignment data
        assignment: {
            type: Object,
            default: null
        },

        hideDescription: {
            type: Boolean,
            default: false
        },

        hideClub: {
            type: Boolean,
            default: false
        }
    }
}
</script>
